import { render, staticRenderFns } from "./funciones.vue?vue&type=template&id=725e571e&scoped=true&"
import script from "./funciones.vue?vue&type=script&lang=ts&"
export * from "./funciones.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725e571e",
  null
  
)

export default component.exports